const uploadScopeSelector = {
  metadataOptions: {
    projects: {
      label: "Þetta verkefni",
      description:
        "Aðeins meðlimir þessa verkefnis geta fundið og óskað eftir þessu gagnasafni",
    },
    org: {
      label: "Allir í stofnuninni þinni",
      description:
        "Allir meðlimir stofnunarinnar sjá þetta gagnasafn í yfirliti gagnasafna og geta óskað eftir aðgangi",
    },
    private: {
      label: "Falið",
      description: "Ekki sýnilegt neinum",
    },
  },
  downloadOptions: {
    none: {
      label: "Beiðni áskilin",
      description:
        "Rannsakendur verða að senda inn gagnabeiðni til að fá aðgang að þessu gagnasafni",
    },
    project: {
      label: "Allir meðlimir verkefnisins",
      description:
        "Hvaða meðlimur verkefnisins sem er getur sótt gögnin beint (auðkenni fjarlægð)",
    },
    selectedMembers: {
      label: "Aðeins valdir meðlimir",
      description:
        "Aðeins tilteknir meðlimir verkefnisins sem þú velur geta sótt gögnin beint",
    },
  },
  catalogVisibility: {
    heading: "Sýnileiki í yfirliti gagnasafna — hver getur fundið þetta gagnasafn",
    helpTip:
      "Hver getur SÉÐ að þetta gagnasafn er til og þar með óskað eftir því. Þetta er óháð því hver getur sótt það: gagnasafn getur birst í yfirlitinu en samt krafist samþykktrar beiðni til að lesa það.",
  },
  downloadAccess: {
    heading: "Niðurhalsaðgangur — hver getur sótt gögnin án beiðni",
    helpTip:
      "Hver getur strax LESIÐ skrána, með auðkennin fjarlægð, án þess að þurfa samþykkta beiðni. Allir aðrir sem sjá gagnasafnið verða fyrst að senda inn gagnabeiðni.",
    membersWhoCanDownload: "Meðlimir verkefnisins sem geta sótt gögnin:",
    onlyYouCanDownload:
      "Aðeins þú getur sótt gögnin. Veldu fleiri meðlimi til að deila aðgangi.",
  },
};

export default uploadScopeSelector;
